import React from 'react'

import { typography } from 'assets/styles'
import VerifiedIcon from 'components/Icons/VerifiedIcon'
import styled from 'styled-components'

const Container = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    margin: 0 0 20px 0;
    padding: 0;
`

const Title = styled.h1`
    ${typography.Hero24};
    padding: 0;
    margin-top: 0;
    margin-bottom: 0;
`

const Label = styled.h3`
    ${typography.BodyCopy16};
    padding: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    margin-top: 0;
    margin-bottom: 0;

    > div {
        margin-left: 0.5em;
    }
`

type TitlebarProps = {
    readonly title: string
}

export function Titlebar({ title }: TitlebarProps): JSX.Element {
    return (
        <Container>
            <Title data-testid="newapplication-title">{title}</Title>
            <Label data-testid="newapplication-label">
                <div>Instant decisions • No credit impact</div>
                <div>
                    <VerifiedIcon />
                </div>
            </Label>
        </Container>
    )
}

export default Titlebar
